export default __webpack_public_path__ + "static/carriage_view-7e5243764a0eb85f5848fe56df9959bf.jpg";